export default "__VITE_ASSET__CcHmKKtB__"